import React, { useState, useRef, useEffect } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import NoImg from "../../assets/images/small/img-15.jpg";
import { useParams } from 'react-router-dom';
import { getDeveloperbyname, getdevelopers } from "service/api";

const BuilderDescription = () => {
    const [activeTab, setActiveTab] = useState("Overview");
    const [builderTab, setBuilderTab] = useState("Vision");
    const completedScrollRef = useRef(null);
    const { dev_name } = useParams();
    const [error, setError] = useState(null);
    const [developer, setDeveloper] = useState(null);
    const [developersData, setDevelopersData] = useState([]);
    const [locations, setLocations] = useState([]);
    const [customActiveTab, setCustomActiveTab] = useState("");

    useEffect(() => {
        const fetchDeveloper = async () => {
            try {
                const response = await getDeveloperbyname(dev_name);
                if (response?.data) {
                    setDeveloper(response.data.data);
                } else {
                    setError("Developer not found.");
                }
            } catch (err) {
                setError("Error fetching Developer details.");
                console.error(err);
            }
        };

        fetchDeveloper();
    }, [dev_name]);

    useEffect(() => {
        const getDeveloper = async () => {
            try {
                let response = await getdevelopers();
                setDevelopersData(response.data);

                // Extract unique locations from all developers
                const allLocations = new Set();
                response.data.forEach(dev => {
                    dev.ongoing_projects?.forEach(project => {
                        if (project.location) {
                            allLocations.add(project.location);
                        }
                    });
                    dev.completed_projects?.forEach(project => {
                        if (project.location) {
                            allLocations.add(project.location);
                        }
                    });
                });

                // Convert Set to array and create location objects with IDs
                const locationsArray = Array.from(allLocations).map((location, index) => ({
                    id: (index + 1).toString(),
                    name: location
                }));

                setLocations(locationsArray);

                // Set first location as active tab if locations exist
                if (locationsArray.length > 0) {
                    setCustomActiveTab(locationsArray[0].id);
                }
            } catch (error) {
                console.error("Error fetching developers:", error);
                setError("Error fetching developers data.");
            }
        };

        getDeveloper();
    }, []);


    const tabs = [
        "Overview",
        "Ongoing Projects",
        "Price Trends",
        "Builder Speak",
        "Completed Project",
        "Other Builders"
    ];

    if (error) {
        return <div className="text-danger mt-5">{error}</div>;
    }

    if (!developer) {
        return <div className="text-light mt-5">Loading...</div>;
    }

    return (
        <div style={{ marginTop: "100px" }}>
            <div className="container py-4">
                {/* Top Section */}
                <div
                    className="rounded-top p-4 d-flex flex-column align-items-center shadow-sm"
                    style={{ background: "rgba(255, 255, 255, 0.1)" }}
                >
                    <img
                        src={developer.logo || NoImg}
                        alt="Builder Logo"
                        className="rounded-circle shadow mb-3"
                        style={{
                            width: 100,
                            height: 100,
                            objectFit: "cover",
                            backgroundColor: "#fff"
                        }}
                    />

                    <div className="d-flex justify-content-center flex-wrap text-light border-bottom mt-3 w-100">
                        {tabs.map((tab, i) => (
                            <button
                                key={i}
                                className={`tab-button text-light ${activeTab === tab ? "active" : ""}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Overview Content */}
                {activeTab === "Overview" && (
                    <div>
                        <Row className="mt-5">
                            <Col md={8}>
                                <h3 className="fw-bold text-light">
                                    {developer.dev_name}
                                </h3>
                                <p className="fw-semibold text-light mb-1">Office Address</p>
                                <p className="text-muted mb-2">
                                    <FaMapMarkerAlt className="me-2 text-primary" />
                                    {developer.office_Address || "Address not available"}
                                </p>
                                <p className="fw-semibold text-light mb-1">Operating in Cities</p>
                                <p className="text-muted mb-4 text-light">
                                    {developer.operating_cities?.map(city => city.city).join(", ") || "Cities not specified"}
                                </p>
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <p className="fw-semibold text-light mb-1">Deals in Property Type</p>
                                        <p className="text-muted">{developer.property_types || "Not specified"}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p className="fw-semibold text-light mb-1">Experience</p>
                                        <p className="text-muted">
                                            {developer.operating_since ? `${new Date().getFullYear() - parseInt(developer.operating_since)}+ years` : "Not specified"}
                                        </p>
                                    </Col>
                                </Row>
                                <div>
                                    <h5 className="fw-bold text-light mb-2">About {developer.dev_name}</h5>
                                    <p className="text-muted">
                                        {developer.about || "No description available"}
                                        {developer.about && <span className="text-danger fw-semibold"> Read more</span>}
                                    </p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <Card
                                    className="border-0 shadow-lg"
                                    style={{
                                        background: "rgba(255, 255, 255, 0.1)",
                                        borderRadius: "1.5rem"
                                    }}
                                >
                                    <CardBody>
                                        <h5 className="fw-bold mb-4 text-center text-light">All Projects</h5>
                                        <div className="d-flex justify-content-between p-3 mb-3 rounded bg-warning shadow-sm">
                                            <span className="fw-bold text-dark">{developer.total_projects || "0"}+</span>
                                            <span className="text-dark">Total Projects</span>
                                        </div>
                                        <div className="d-flex justify-content-between p-3 mb-3 rounded bg-warning shadow-sm">
                                            <span className="fw-bold text-dark">{developer.ready_projects || "0"}+</span>
                                            <span className="text-dark">Ready to Move Projects</span>
                                        </div>
                                        <div className="d-flex justify-content-between p-3 rounded bg-warning shadow-sm">
                                            <span className="fw-bold text-dark">{developer.under_construction || "0"}+</span>
                                            <span className="text-dark">Under Construction</span>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                )}

                {/* Ongoing Projects Content */}
                {activeTab === "Ongoing Projects" && (
                    <div className="mt-5">
                        <h4 className="fw-bold text-light mb-4">Ongoing Projects by {developer.dev_name}</h4>

                        {/* Filters (optional) */}
                        <div className="d-flex gap-3 mb-4">
                            <select className="form-select w-auto">
                                <option>All Cities</option>
                            </select>
                            <select className="form-select w-auto">
                                <option>Project Type</option>
                            </select>
                            <select className="form-select w-auto">
                                <option>Status</option>
                            </select>
                        </div>

                        <Row>
                            {developer.ongoing_projects?.length > 0 ? (
                                developer.ongoing_projects.map((project, idx) => (
                                    <Col md={4} key={idx} className="mb-4">
                                        <Card className="shadow-sm border-0 h-100 text-light"
                                            style={{ background: "rgba(255, 255, 255, 0.1)", borderRadius: "15px", padding: "20px" }}>
                                            {/* Show first image if available, otherwise show NoImg */}
                                            <img
                                                src={project.images?.length > 0 ? project.images[0].image_url : NoImg}
                                                alt={project.title}
                                                className="card-img-top"
                                                style={{ height: 200, objectFit: "cover" }}
                                            />
                                            <CardBody>
                                                <h6 className="fw-bold text-light">{project.title}</h6>
                                                <p className="text-light mb-1">{project.location}</p>
                                                <p className="text-light mb-1">₹{project.price} Cr</p>
                                                <p className="text-light">Under Construction</p>
                                                <Button color="danger" outline className="w-100 mt-2">
                                                    Contact Builder
                                                </Button>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <Col className="text-light">
                                    No ongoing projects available
                                </Col>
                            )}
                        </Row>

                        {developer.ongoing_projects?.length > 0 && (
                            <p className="text-danger fw-bold mt-3" style={{ cursor: "pointer" }}>
                                Show all Projects
                            </p>
                        )}
                    </div>
                )}

                {/* Price Trends Content */}
                {activeTab === "Price Trends" && (
                    <div className="mt-5">
                        <h4 className="font-bold text-white text-xl mb-4">Price Trends</h4>
                        <div className="flex flex-wrap gap-4 mb-6">
                            <select className="bg-white/90 backdrop-blur-sm text-gray-800 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
                                {developer.operating_cities?.map((city, idx) => (
                                    <option key={idx}>{city.city}</option>
                                ))}
                            </select>

                            <select className="bg-white/90 backdrop-blur-sm text-gray-800 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
                                {developer.ongoing_projects?.map((project, idx) => (
                                    <option key={idx}>{project.title}</option>
                                ))}
                            </select>
                        </div><br />
                        <div
                            className="rounded-2xl p-6 backdrop-blur-md"
                            style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                        >
                            <br />
                            <div className="bg-white/10 text-white text-lg rounded-lg h-64 flex items-center justify-center">
                                No Trend Available
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === "Builder Speak" && (
                    <div className="mt-5">
                        <h4 className="font-bold text-white text-xl mb-4">Builder Speak</h4>

                        <div className="rounded-2xl p-6 backdrop-blur-md" style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>

                            <div className="flex space-x-4 mb-6">
                                {["Vision", "Mission", "Values"].map((tab) => (
                                    <button
                                        key={tab}
                                        onClick={() => setBuilderTab(tab)}
                                        className={`px-5 py-2 rounded-md font-medium text-sm transition duration-300 ${builderTab === tab
                                            ? "bg-[#d8232a] text-danger shadow-md"
                                            : "text-black hover:bg-white/10"
                                            }`}
                                    >
                                        {tab}
                                    </button>
                                ))}
                            </div>

                            <div className="bg-white/10 text-white text-base rounded-xl p-5 leading-relaxed min-h-[200px] shadow-inner">
                                {builderTab === "Vision" && (
                                    <p>
                                        {developer.vision || "No vision statement available"}
                                    </p>
                                )}

                                {builderTab === "Mission" && (
                                    <p>
                                        {developer.mission || "No mission statement available"}
                                    </p>
                                )}

                                {builderTab === "Values" && (
                                    <p>
                                        {developer.company_values || "No company values available"}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Completed Project Content */}
                {activeTab === "Completed Project" && (
                    <div className="mt-5">
                        <h4 className="fw-bold text-light mb-4">Completed Project by {developer.dev_name}</h4>

                        <div className="d-flex gap-3 mb-4">
                            <select className="form-select w-auto">
                                <option>All Cities</option>
                            </select>
                            <select className="form-select w-auto">
                                <option>Project Type</option>
                            </select>
                        </div>

                        <div className="d-flex justify-content-end mb-2 gap-2">
                            <Button color="light" onClick={() => completedScrollRef.current.scrollLeft -= 300}><FaArrowLeft /></Button>
                            <Button color="light" onClick={() => completedScrollRef.current.scrollLeft += 300}><FaArrowRight /></Button>
                        </div>

                        <div
                            className="d-flex overflow-auto"
                            ref={completedScrollRef}
                            style={{ scrollBehavior: "smooth", gap: "20px" }}
                        >
                            {developer.completed_projects?.length > 0 ? (
                                developer.completed_projects.map((project, idx) => (
                                    <div key={idx} style={{ minWidth: "300px", flex: "0 0 auto" }}>
                                        <Card
                                            className="shadow-sm border-0 h-100 text-light"
                                            style={{
                                                background: "rgba(255, 255, 255, 0.1)",
                                                borderRadius: "15px",
                                                padding: "20px",
                                            }}
                                        >
                                            {/* Show first image if available, otherwise show NoImg */}
                                            <img
                                                src={project.images?.length > 0 ? project.images[0].image_url : NoImg}
                                                alt={project.title}
                                                className="card-img-top"
                                                style={{ height: 200, objectFit: "cover" }}
                                            />
                                            <CardBody>
                                                <h6 className="fw-bold text-light">{project.title}</h6>
                                                <p className="text-light mb-1">{project.location}</p>
                                                <p className="text-light mb-1">₹{project.price} Cr</p>
                                                <p className="text-light">Completed</p>
                                                <Button color="danger" outline className="w-100 mt-2">
                                                    Contact Builder
                                                </Button>
                                            </CardBody>
                                        </Card>
                                    </div>
                                ))
                            ) : (
                                <div className="text-light">No completed projects available</div>
                            )}
                        </div>

                        {developer.completed_projects?.length > 0 && (
                            <p className="text-danger fw-bold mt-3" style={{ cursor: "pointer" }}>
                                Show all Projects
                            </p>
                        )}
                    </div>
                )}

                {activeTab === "Other Builders" && (
                    <div className="mt-5">
                        <h4 className="fw-bold text-light mb-4">Other Builders</h4>

                        {/* Arrow Controls */}
                        <div className="d-flex justify-content-end mb-3 gap-2">
                            <Button color="light" onClick={() => completedScrollRef.current.scrollLeft -= 300}>
                                <FaArrowLeft />
                            </Button>
                            <Button color="light" onClick={() => completedScrollRef.current.scrollLeft += 300}>
                                <FaArrowRight />
                            </Button>
                        </div>

                        {/* Scrollable Builder Cards */}
                        <div
                            className="d-flex overflow-auto"
                            ref={completedScrollRef}
                            style={{ scrollBehavior: "smooth", gap: "20px" }}
                        >
                            {developersData
                                ?.filter(dev => dev.dev_name !== developer?.dev_name) // Exclude current developer
                                ?.map((builder, idx) => (
                                    <div key={idx} style={{ minWidth: "240px", flex: "0 0 auto", marginBottom: "5%" }}>
                                        <Card
                                            className="shadow-sm border-0 text-center text-light"
                                            style={{
                                                background: "rgba(255, 255, 255, 0.05)",
                                                borderRadius: "12px",
                                                padding: "20px",
                                                height: "100%",
                                            }}
                                        >
                                            {builder.logo && (
                                                <img
                                                    src={builder.logo}
                                                    alt={builder.dev_name}
                                                    className="rounded-circle mb-3"
                                                    style={{
                                                        width: "80px",
                                                        height: "80px",
                                                        objectFit: "cover",
                                                        margin: "0 auto"
                                                    }}
                                                />
                                            )}
                                            <CardBody className="p-0">
                                                <h2 className="fw-bold text-light mb-1" style={{ fontSize: "1.5rem" }}>
                                                    {builder.dev_name}
                                                </h2>
                                                <div className="d-flex justify-content-between px-3 mt-4">
                                                    <div>
                                                        <p className="mb-1 text-muted small">Experience</p>
                                                        <p className="text-light fw-semibold">
                                                            {builder.operating_since
                                                                ? `${new Date().getFullYear() - parseInt(builder.operating_since)} Years`
                                                                : "N/A"}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="mb-1 text-muted small">Total Projects</p>
                                                        <p className="text-light fw-semibold">
                                                            {builder.total_projects || "0"}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <p className="mb-1 text-muted small">Operating In</p>
                                                    <p className="text-light fw-semibold">
                                                        {builder.operating_cities?.map(c => c.city).join(", ") || "N/A"}
                                                    </p>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                ))}
                        </div>
                    </div>
                )}
            </div>

            <style>
                {`
                        .tab-button {
                            color: #666;
                            border: none;
                            padding: 0.75rem 1.5rem;
                            background: transparent;
                            transition: all 0.2s ease-in-out;
                            font-weight: 500;
                        }

                        .tab-button:hover {
                            color: #dc3545;
                            font-weight: 600;
                        }

                        .tab-button.active {
                            border-bottom: 2px solid #dc3545;
                            color: #dc3545;
                            font-weight: 700;
                        }
                    `}
            </style>
        </div>
    );
};

export default BuilderDescription; 